import * as actionTypes from './actionTypes';

export const sendForgotUsernameEmail = (email: string) => {
  return {
    type: actionTypes.forgotUsername.SEND_EMAIL,
    email: email,
  };
};

export const sendForgotUsernameEmailResponse = (data:any) => {
  return {
    type: actionTypes.forgotUsername.SEND_EMAIL_RESPONSE,
    emailResponse: data,
  };
};

export const resetForgotUsernameErrorMessage = () => {
  return {
    type: actionTypes.forgotUsername.CLEAR_ERROR_MESSAGE
  };
};
